import React from 'react';
import {
  COUNTRY_OPTIONS,
  nationalPlaceholderForCountry,
  maxNationalDigitsForCountry,
  normalizeNationalInput
} from '../utils/phoneCountry';

/**
 * Country dial code + national number (digits). Default list has India (+91).
 */
export default function PhoneCountryField({
  countryCode,
  nationalNumber,
  onCountryChange,
  onNationalChange,
  disabled = false,
  nationalPlaceholder,
  idPrefix = 'phone'
}) {
  const placeholder =
    nationalPlaceholder !== undefined && nationalPlaceholder !== null
      ? nationalPlaceholder
      : nationalPlaceholderForCountry(countryCode);

  const handleCountrySelect = (e) => {
    const nextCc = e.target.value;
    onCountryChange(nextCc);
    const nextMax = maxNationalDigitsForCountry(nextCc);
    const nat = String(nationalNumber || '').replace(/\D/g, '');
    if (nat.length > nextMax) {
      onNationalChange(nat.slice(0, nextMax));
    }
  };

  return (
    <div className="flex gap-2 flex-wrap sm:flex-nowrap">
      <select
        id={`${idPrefix}-cc`}
        value={countryCode}
        onChange={handleCountrySelect}
        disabled={disabled}
        className="shrink-0 w-full sm:w-[148px] px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-sm"
      >
        {COUNTRY_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <input
        id={`${idPrefix}-nat`}
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        value={nationalNumber}
        onChange={(e) => {
          const raw = e.target.value.replace(/\D/g, '');
          onNationalChange(normalizeNationalInput(raw, countryCode));
        }}
        disabled={disabled}
        className="flex-1 min-w-0 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder={placeholder}
      />
    </div>
  );
}
